/* tslint:disable */

import { CMSResource } from "app/resources/cmsresource";
import { AppointmentResource } from "./AppointmentResource";
import { AppointmentStatusResource } from "./AppointmentStatusResource";


export class AppointmentStatusListResource extends CMSResource {

	statusList: AppointmentStatusResource[];

}
